import {
    Coverage,
    Customer,
    Insurance,
    NewRelationCarPayload,
    Payload,
    ReturningRelationCarPayload,
} from '../../../interfaces';
import { newRelationPayload, nonRegularDriver, switchServiceIndication } from './insurance-payload.helper';

export const newRelationCarRequest = (
    coverages: Coverage[] = [],
    insurance: Insurance,
    customer: Customer
): Payload<NewRelationCarPayload> => {
    const payload: NewRelationCarPayload = {
        relation: newRelationPayload(insurance, customer),
        product_bonus_components: null,
        coverages: coverages.map((coverage) => ({ coverage_id: coverage.coverage_id })),
        premium_factor: {
            mileage_auto: insurance.mileage_auto,
            years_driver_license_amount: insurance.years_driver_license_amount,
            no_claims_years_amount: insurance.no_claims_years_amount,
            family_composition_code: customer.family_composition_code,
            start_date: insurance.start_date,
            campaign_code: insurance.campaign_code,
            partner_id: insurance.partner_id,
            partner_component_code: insurance.partner_component_code,
            external_reference_id: insurance.external_reference_id,
        },
        object: {
            license_plate: insurance.license_plate,
            style_trim_id: insurance.style_trim_id,
            vin_last_four_digits_code: insurance.vin_last_four_digits_code,
            licenseplate_holder_code: insurance.licenseplate_holder_code,
        },
        indications: {
            switch_service_indication: switchServiceIndication(insurance),
        },
        codes: {
            in_verleden_aantal_gemelde_schades_code: insurance.in_verleden_aantal_gemelde_schades_code,
        },
    };

    if (['PRTR', 'KIND'].includes(insurance.relation_code)) {
        payload.non_regular_driver = nonRegularDriver(insurance);
    }

    if (customer.recovery_email_address) {
        payload.relation.recovery_email_address = {
            email_address: customer.recovery_email_address,
        };
    }

    return {
        url: 'en-gb/insurance-product/store/new_relation-product-auto',
        payload,
    };
};

export const returningRelationCarRequest = (
    coverages: Coverage[] = [],
    insurance: Insurance,
    customer: Customer
): Payload<ReturningRelationCarPayload> => {
    const payload: ReturningRelationCarPayload = {
        relation: {
            general: {
                birthdate: customer.birthdate,
            },
            residential_address: {
                postal_code: customer.postal_code,
            },
            indications: {
                criminal_record_indication: insurance.criminal_record_indication ? 'N' : 'J',
                insurance_denied_indication: insurance.insurance_denied_indication ? 'N' : 'J',
                condition_agreement_indication: insurance.condition_agreement_indication ? 'J' : 'N',
                electronic_policy_agreement_indication: insurance.electronic_policy_agreement_indication ? 'J' : 'N',
            },
        },
        non_regular_driver_transfer_indication: null,
        coverages: coverages.map((coverage) => ({ coverage_id: coverage.coverage_id })),
        premium_factor: {
            mileage_auto: insurance.mileage_auto,
            years_driver_license_amount: insurance.years_driver_license_amount,
            no_claims_years_amount: insurance.no_claims_years_amount,
            family_composition_code: customer.family_composition_code,
            start_date: insurance.start_date,
            campaign_code: insurance.campaign_code,
            partner_id: insurance.partner_id,
            partner_component_code: insurance.partner_component_code,
            external_reference_id: insurance.external_reference_id,
        },
        object: {
            license_plate: insurance.license_plate,
            style_trim_id: insurance.style_trim_id,
            vin_last_four_digits_code: insurance.vin_last_four_digits_code,
            licenseplate_holder_code: insurance.licenseplate_holder_code,
        },
        indications: {
            switch_service_indication: switchServiceIndication(insurance),
        },
        codes: {
            in_verleden_aantal_gemelde_schades_code: insurance.in_verleden_aantal_gemelde_schades_code,
        },
    };

    if (insurance.related_vehicle_purchased_product_sequence_number) {
        payload.related_vehicle = {
            related_vehicle_purchased_product_sequence_number:
                insurance.related_vehicle_purchased_product_sequence_number,
            end_date: insurance.end_date || null,
        };
        payload.premium_factor.no_claims_years_amount = null;
    }

    if (insurance.non_regular_driver_transfer_indication) {
        payload.non_regular_driver_transfer_indication = insurance.non_regular_driver_transfer_indication;
        payload.premium_factor.no_claims_years_amount = null;
    }

    if (
        ['PRTR', 'KIND'].includes(insurance.relation_code) &&
        insurance.non_regular_driver_transfer_indication !== 'J'
    ) {
        payload.non_regular_driver = nonRegularDriver(insurance);
    }

    return {
        url: 'en-gb/insurance-product/store/existingrelation-product-auto',
        payload,
    };
};
